import type { User } from "src/common/service/types/UserTypes";
import { useAuth0Profile } from "src/common/utils/hooks/useAuth0Profile.js";

/** Auth0's name claim first — the backend user record falls back to the email for Entra-federated accounts with no display name synced yet. */
export const useDisplayName = (user: User): string => {
	const auth0Profile = useAuth0Profile();
	return auth0Profile.name ?? user.name;
};
